import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import SimpleResource from "./SimpleResource.js";

var NetworkError = /*#__PURE__*/function (_Error) {
  _inherits(NetworkError, _Error);

  var _super = _createSuper(NetworkError);

  function NetworkError(response) {
    var _this;

    _classCallCheck(this, NetworkError);

    _this = _super.call(this, response.statusText ||
    /* istanbul ignore next */
    "Network response not 'ok': ".concat(response.status));
    _this.name = 'NetworkError';
    _this.status = response.status;
    _this.response = response;
    return _this;
  }

  return _createClass(NetworkError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Represents an entity to be retrieved from a server.
 * Typically 1:1 with a url endpoint.
 * @see https://resthooks.io/docs/api/resource
 */


var Resource = /*#__PURE__*/function (_SimpleResource) {
  _inherits(Resource, _SimpleResource);

  var _super2 = _createSuper(Resource);

  function Resource() {
    _classCallCheck(this, Resource);

    return _super2.apply(this, arguments);
  }

  _createClass(Resource, null, [{
    key: "fetchResponse",
    value:
    /** Perform network request and resolve with HTTP Response */
    function fetchResponse(input, init) {
      var options = init;

      if (!options.body || typeof options.body === 'string') {
        options = _objectSpread(_objectSpread({}, options), {}, {
          headers: _objectSpread({
            'Content-Type': 'application/json'
          }, options.headers)
        });
      }

      return fetch(input, options).then(function (response) {
        if (!response.ok) {
          throw new NetworkError(response);
        }

        return response;
      }).catch(function (error) {
        // ensure CORS, network down, and parse errors are still caught by NetworkErrorBoundary
        if (error instanceof TypeError) {
          error.status = 400;
        }

        throw error;
      });
    }
    /** Perform network request and resolve with json body */

  }, {
    key: "fetch",
    value: function fetch(input, init) {
      return this.fetchResponse(input, init).then(function (response) {
        var _response$headers$get;

        if (!((_response$headers$get = response.headers.get('content-type')) != null && _response$headers$get.includes('json')) || response.status === 204) return response.text();
        return response.json().catch(function (error) {
          error.status = 400;
          throw error;
        });
      });
    }
  }]);

  return Resource;
}(SimpleResource);

export { Resource as default };